import DuelResults from './DuelResults';

export default DuelResults;